module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.messages.length) ? _c('div', {
    attrs: {
      "id": "service-msg"
    }
  }, _vm._l((_vm.openedMessages), function(msg) {
    return _c('div', {
      key: msg.text,
      staticClass: "msg-item"
    }, [_vm._v("\n    " + _vm._s(msg.text) + "\n    "), _c('a', {
      staticClass: "close",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.close(msg)
        }
      }
    }, [_vm._v("×")])])
  }), 0) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f3c5ed80"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/generic/ServiceMessage.vue
// module id = 1074
// module chunks = 1